import _ from 'lodash-es';

angular
  .module('shbdeployer.kubernetes')
  .filter('kubernetesPodStatusColor', function () {
    'use strict';
    return function (text) {
      var status = _.toLower(text);
      switch (status) {
        case 'работает':
          return 'success';
        case 'ожидание':
          return 'warning';
        case 'завершён':
          return 'info';
        default:
          return 'danger';
      }
    };
  })
  .filter('kubernetesPodConditionStatusBadge', function () {
    'use strict';
    return function (status, type) {
      switch (type) {
        case 'Unschedulable':
          switch (status) {
            case 'True':
              return 'fa-exclamation-triangle red-icon';
            case 'False':
              return 'fa-check green-icon';
            case 'Unknown':
              return 'fa-exclamation-circle orange-icon';
          }
          break;
        case 'PodScheduled':
        case 'Ready':
        case 'Initialized':
        case 'ContainersReady':
          switch (status) {
            case 'True':
              return 'fa-check green-icon';
            case 'False':
              return 'fa-exclamation-triangle red-icon';
            case 'Unknown':
              return 'fa-exclamation-circle orange-icon';
          }
          break;
        default:
          return 'fa-question-circle red-icon';
      }
    };
  })
  .filter('kubernetesPodConditionStatusText', function () {
    'use strict';
    return function (status, type) {
      switch (type) {
        case 'Unschedulable':
          switch (status) {
            case 'True':
              return 'Тревога';
            case 'False':
              return 'Норма';
            case 'Unknown':
              return 'Предупреждение';
          }
          break;
        case 'PodScheduled':
        case 'Ready':
        case 'Initialized':
        case 'ContainersReady':
          switch (status) {
            case 'True':
              return 'Норма';
            case 'False':
              return 'Тревога';
            case 'Unknown':
              return 'Предупреждение';
          }
          break;
        default:
          return 'Неизвестно';
      }
    };
  });
